/* unplugin-vue-components disabled */import script from "./WithdrawEvent.vue?vue&type=script&setup=true&lang=js"
export * from "./WithdrawEvent.vue?vue&type=script&setup=true&lang=js"

import "./WithdrawEvent.vue?vue&type=style&index=0&id=5b60c944&lang=less"

const __exports__ = script;

export default __exports__